import React from "react";
import { ReactComponent as UnderLineHeader } from "../../assets/komet-assets/underLineHeader.svg";
import { ReactComponent as GermanFlag } from "../../assets/komet-assets/GermanFlag.svg";

function SectionHeaderTitle({ title, subtitle, withFlag = true, withSubTitle = false }) {
    return (
        <div className="relative w-fit py-10">
            <div className="smooth clr-text-primary space-y-5 px-5 py-5">
                <h1 className="text-4xl px-3 py-1  font-w-bold">{title} </h1>
                {withSubTitle && <span className="text-earthYellow-500 text-2xl">{subtitle}</span>}
            </div>
            <div>
                <UnderLineHeader className="absolute mx-auto md:mx-0 w-32 md:w-auto left-0 right-0 bottom-5" />
            </div>
            {withFlag && (
                <GermanFlag className="absolute w-14 h-14 md:w-auto md:h-auto left-6 top-10 md:top-0 opacity-50" />
            )}
        </div>
    );
}

export default SectionHeaderTitle;
